'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/ui/button';
import { Item, ItemActions, ItemContent, ItemDescription } from '@/components/ui/item';
import posthog from 'posthog-js';
import { useEffect, useState } from 'react';
export function CookiesBanner() {
  const $ = _c(6);
  const [consentGiven, setConsentGiven] = useState();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setConsentGiven(posthog.get_explicit_consent_status());
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      posthog.opt_in_capturing();
      setConsentGiven("granted");
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleAcceptCookies = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      posthog.opt_out_capturing();
      setConsentGiven("denied");
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleDeclineCookies = t3;
  if (consentGiven !== "pending") {
    return null;
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ItemDescription>We use tracking cookies to understand how you use the product and help us improve it.<br />Please accept cookies to help us improve.</ItemDescription>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Item variant="outline" className="fixed bottom-2 left-2 bg-background z-99"><ItemContent className="flex-col gap-2">{t4}<ItemActions className="w-full justify-end-safe"><Button variant="outline" onClick={handleDeclineCookies}>Decline cookies</Button><Button onClick={handleAcceptCookies}>Accept cookies</Button></ItemActions></ItemContent></Item>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}